const SET_PARTNERS = (state, payload) => {
  state.partners = payload;
}

export default {
  SET_PARTNERS
}